
var Model = require("../types/Model.js");
var par = require("par");

module.exports = Model({
	name: "managedgroupformorderedlist",
	init: init,
	uninit: uninit,
	listeners: listeners
});

function init() {
	this.push([]);
}

function uninit() {
}

function listeners() {
	return {
		"managedgroupformlist:updated": handle_update
	};
}

function handle_update(forms) {
	var sortedforms = Object.keys(forms)
		.sort(par(ordericons, forms));
	this.push(sortedforms);
}

/**
 * performs a sort while accounting for some items
 * being 'undefined'.  'undefined' is treated as greater than a number
 * so they get pushed to end of the sorted array.
 */
function ordericons(forms, x, y) {
	var xx = forms[x].schema.order;
	var yy = forms[y].schema.order;
	if (xx > yy || xx === undefined) return 1;
	if (xx < yy || yy === undefined) return -1;
	return 0;
}
